import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Switch } from 'react-router';
import { BrowserRouter, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PrivateRoute from './util/PrivateRoute';
import CustomerArea from './pages/account/customer/CustomerArea';
import TesterArea from './pages/account/tester/TesterArea';

import LoginPage from './pages/LoginPage';
import { ResetFBPasswordPage, ResetPasswordPage, ResetPasswordResponse } from './pages/ResetPasswordPage';
import SignupPage from './pages/SignupPage';
import { UnsubscribePage } from './pages/Unsubscribe';


import Header from './components/Header';
import RegisterApproved from './components/RegisterApproved';
import RegisterConfirm from './components/RegisterConfirm';

import CycleCreationResult from './components/Cycles/CycleCreationResult';

import NewCycleWizard from './components/Wizard/NewCycleWizard';

import Impersonate from './components/Impersonate';
import RedirectLogin from './components/RedirectLogin';

import PageNotFound from './components/PageNotFound';

import Account from './components/Account';
import CompleteProfile from './components/CompleteProfile';
import EmailPending from './components/EmailPending';





import Footer from './components/Footer';

import { GoogleOAuthProvider } from '@react-oauth/google';
import Pricing from './components/Pricing/Pricing';
import config from './config';
import useResolution from './hooks/useResolution';
import actions from './redux/actions';
import { OperationStatus } from './types/OperationStatus';
import { UserRole } from './types/UserRole';

console.log(`TESTPOINT APP V${process.env.REACT_APP_VERSION}`);

// TODO too many imports, split
// TODO check if a JWT token present and valid. if it's expired, delete it
// TODO move routes to a separate file

const mapStateToProps = (state) => ({
  loginStatus: state.loginStatus.status,
  impersonateStatus: state.impersonateStatus.status,
  user: state.user,
  devices: state.devices,
  browsers: state.browsers,
});

const mapDispatchToProps = (dispatch) => ({
  getDevices: () => dispatch(actions.getDevices()),
  getBrowsers: () => dispatch(actions.getBrowsers()),
  checkLogin: () => dispatch(actions.checkLogin()),
});

const AppHooks = ({ children }) => {
  const location = useLocation();
  useEffect(function onLocationChange() {
    window.scrollTo(0, 0);
  }, [location]);
  useResolution();
  return <>{children}</>;
};

class App extends Component<any> {
  componentDidMount() {
    this.props.getDevices();
    this.props.getBrowsers();
    if (window.location.pathname.indexOf("impersonate") == -1) {
      this.props.checkLogin();
    }
  }

  render() {
    const { user } = this.props;
    const loaderActive =
      !this.props.devices.models.length ||
      !this.props.browsers.names.length ||
      this.props.impersonateStatus === OperationStatus.processing;

    const marketSiteURLBase = config.marketingSiteBaseURL;

    return (
      <GoogleOAuthProvider clientId={config.GoogleClientId}>
        <BrowserRouter>
          <div className="app">
            <ToastContainer
              rtl={false}
              pauseOnHover
              closeOnClick
              hideProgressBar
              autoClose={3000}
              draggable={false}
              newestOnTop={false}
              position="top-right"
            />
            <Header />
            <main>
              {loaderActive ? (
                <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}>
                  <CircularProgress sx={{ color: '#fff' }} />
                </Backdrop>
              ) : (
                <AppHooks>
                  <Switch>

                    {/* Route marketing pages to the standalone marketing site. */}
                    <Route exact path="/">
                      {(this.props.impersonateStatus === OperationStatus.success &&
                        user.role !== UserRole.Anonymous) ? <Redirect to="/account" /> :
                        <Redirect to="/login" />}
                    </Route>

                    <Route path="/faqs" component={() => { window.location.href = `${marketSiteURLBase}/faqs`; return null; }} />

                    <Route path="/tester" component={() => { window.location.href = `${marketSiteURLBase}/tester`; return null; }} />

                    <Route path="/contact" component={() => { window.location.href = `${marketSiteURLBase}/contact`; return null; }} />

                    <Route path="/contactsales" component={() => { window.location.href = `${marketSiteURLBase}/contactsales`; return null; }} />

                    <Route path="/contactsupport" component={() => { window.location.href = `${marketSiteURLBase}/contactsupport`; return null; }} />

                    <Route path="/privacy" component={() => { window.location.href = `${marketSiteURLBase}/privacy`; return null; }} />

                    <Route path="/terms" component={() => { window.location.href = `${marketSiteURLBase}/terms`; return null; }} />

                    <Route path="/wizard" component={() => { window.location.href = `${marketSiteURLBase}/pricing`; return null; }} />

                    <Route path="/login" exact component={LoginPage} />
                    <Route path="/signup" exact component={SignupPage} />

                    <Route path="/reset-password-req" exact component={ResetPasswordPage} />
                    <Route path="/reset-fb-password-req" exact component={ResetFBPasswordPage} />
                    <Route path="/reset-password" exact component={ResetPasswordResponse} />
                    <Route path="/unsubscribe" exact component={UnsubscribePage} />

                    <Route path="/registerconfirm" component={RegisterConfirm} />
                    <Route path="/register-approved" component={RegisterApproved} />
                    <Route path="/forgot-password" component={ResetPasswordResponse} />
                    <Route path="/impersonate/:token" component={Impersonate} />
                    <Route path="/redirect-login" component={RedirectLogin} />

                    <Route path="/cycle-creation-result" component={CycleCreationResult} />

                    {/* Retired We-Test pages: their content lives on the marketing site now */}
                    <Route path="/samplereports" component={() => { window.location.href = `${marketSiteURLBase}`; return null; }} />
                    <Route path="/becomeatester" component={() => { window.location.href = `${marketSiteURLBase}/tester`; return null; }} />
                    <Route path="/cycles" component={() => { window.location.href = `${marketSiteURLBase}/pricing`; return null; }} />
                    <Route path="/articles" component={() => { window.location.href = `${marketSiteURLBase}/blog`; return null; }} />
                    <Route path="/contactus" component={() => { window.location.href = `${marketSiteURLBase}/contact`; return null; }} />
                    <Route path="/about" component={() => { window.location.href = `${marketSiteURLBase}`; return null; }} />

                    {/* <Route exact path="/pricing" >
                    <Redirect to="/pricing/speedtest" />
                  </Route>
                  <Route path="/pricing/:pricingType/:reload?" component={Pricing} />
                  <Route path="/custom/:reload?" component={NewCycleWizard} /> */}

                    <PrivateRoute exact
                      path="/firstcycle"
                      role={user.role}
                      status={user.status}
                      component={Pricing}
                    >
                      <Redirect to="/pricing/firstcycle" />
                    </PrivateRoute>

                    <PrivateRoute exact
                      path="/custom"
                      role={user.role}
                      status={user.status}
                      component={NewCycleWizard} />

                    <PrivateRoute exact
                      path="/pricing"
                      role={user.role}
                      status={user.status}
                    >
                      <Redirect to="/pricing/speedtest" />
                    </PrivateRoute>

                    <PrivateRoute
                      exact
                      path="/pricing/:pricingType"
                      role={user.role}
                      component={Pricing}
                      status={user.status}
                    />

                    <PrivateRoute
                      exact
                      path="/account"
                      role={user.role}
                      component={Account}
                      status={user.status}
                    />
                    {/* All customer pages share one AccountShell; see pages/account/customer/CustomerArea */}
                    <PrivateRoute
                      role={user.role}
                      status={user.status}
                      path="/account/customer"
                      component={CustomerArea}
                    />

                    <PrivateRoute
                      role={user.role}
                      status={user.status}
                      path="/email-pending"
                      component={EmailPending}
                    />
                    <PrivateRoute
                      role={user.role}
                      status={user.status}
                      path="/complete-profile/:step"
                      component={CompleteProfile}
                    />
                    {/* All tester pages share one AccountShell; see pages/account/tester/TesterArea */}
                    <PrivateRoute
                      role={user.role}
                      status={user.status}
                      path="/account/tester"
                      component={TesterArea}
                    />

                    <Route component={PageNotFound} />
                  </Switch>
                </AppHooks>
              )}
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </GoogleOAuthProvider >
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
